import { guideSteps, guideChecklist } from "@/mocks/creatorDirectory";

export default function Guide() {
  return (
    <section id="guide" className="w-full bg-background-100 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto max-w-6xl">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3.5 py-1.5 text-xs font-medium text-primary-700">
            <i className="ri-route-line"></i>
            选博主指南
          </span>
          <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
            五步找到适合你的博主
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-foreground-700 md:text-base">
            关注谁不该只看名气。按下面这套顺序过一遍，通常几分钟就能判断出一个创作者值不值得长期追。
          </p>
        </div>

        <div className="mt-10 grid gap-10 lg:grid-cols-[1.35fr_1fr] lg:gap-14">
          <ol className="relative space-y-4">
            {guideSteps.map((step, index) => (
              <li
                key={step.step}
                className="relative flex gap-5 rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
              >
                <div className="flex flex-col items-center">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-500 font-heading text-sm font-bold text-background-50">
                    {step.step}
                  </span>
                  {index < guideSteps.length - 1 && (
                    <span className="mt-2 hidden w-px flex-1 bg-background-300 md:block"></span>
                  )}
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2.5">
                    <i className={`${step.icon} text-lg text-accent-600`}></i>
                    <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                      {step.title}
                    </h3>
                  </div>
                  <p className="mt-2.5 text-sm leading-relaxed text-foreground-700">{step.desc}</p>
                </div>
              </li>
            ))}
          </ol>

          <aside className="lg:sticky lg:top-24 lg:self-start">
            <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-7">
              <h3 className="flex items-center gap-2.5 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-checkbox-multiple-line text-xl text-primary-600"></i>
                关注前的自检清单
              </h3>
              <p className="mt-3 text-xs leading-relaxed text-foreground-600">
                打开创作者主页时，顺手指认这几个点，基本就能判断内容是否稳定、是否对味。
              </p>
              <ul className="mt-5 space-y-3">
                {guideChecklist.map((item) => (
                  <li key={item} className="flex items-start gap-2.5 text-sm text-foreground-800">
                    <i className="ri-check-line mt-0.5 shrink-0 text-primary-600"></i>
                    <span className="leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-6 rounded-lg bg-primary-500/8 p-4">
                <p className="text-xs leading-relaxed text-primary-800">
                  <i className="ri-lightbulb-flash-line mr-1.5"></i>
                  小建议：先关注三到五个不同领域的创作者试看一周，比一次性关注几十个更容易沉淀出稳定的观看习惯。
                </p>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}